import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-paper-sent-dialog',
  templateUrl: './paper-sent-dialog.component.html',
  styleUrls: ['./paper-sent-dialog.component.scss']
})
export class PaperSentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PaperSentDialogComponent>,
    private router: Router
  ) { }

  public send(): void {
    this.router.navigate(['/tracing'], { queryParams: { tab: 1 } });
    this.dialogRef.close();
  }
}
